import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';

interface IProps {
    customerId: string;
    authorizedUserId: string;
    handleError: (errCode: number) => void;
}
export const useGetStartData = ({ customerId, authorizedUserId, handleError }: IProps) => useQuery(
  'useGetStartData',
  async () => httpService.get(`/api/v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}`),
  {
    enabled: true,
    cacheTime: 0,
    retry: 0,
    refetchOnWindowFocus: false,
    onError: (e: IServerErrorResponse) => {
      const errCode = e?.response?.data?.errors?.[0]?.code || 0;
      handleError(errCode);
    },
  },
);
